// Shared UI Library Components
import { CustomIcon, EIconName } from "@ppmcore/seven-ppm-core-shared-components-react";

export const CCounsellorPageMenuList = [
  {
    label: 'Personal Data',
    path: `counsellors/{id}`,
    icon: <CustomIcon name={ EIconName.PersonOff }/>,
    activeIcon: <CustomIcon name={ EIconName.PersonOn }/>
  },
  {
    label: 'Pricing Settings',
    path: 'counsellors/{id}/rates',
    icon: <CustomIcon name={ EIconName.CounsellorsRating }/>,
    activeIcon: <CustomIcon name={ EIconName.CounsellorsRatingFill }/>
  },
  // TODO next release
  // {
  //   label: 'Reviews',
  //   path: 'counsellors/{id}/reviews',
  //   icon: <CustomIcon name={ EIconName.StarOutlined }/>,
  //   activeIcon: <CustomIcon name={ EIconName.StarFill }/>
  // },
];
